export const getInsuranceData = (state) => state.insurance.data;
